(function ($) {
  window.addEventListener("DOMContentLoaded", (event) => {
    if ($(".page-template").hasClass("page-template-congratulations")) {

      var orderId = $('.fmp-congratulations').attr('data-order');
      var data = {
        action: "fmp_send_get_started_email",
        nounce: localized.ajaxnonce,
        order_id: orderId,
      };
      $.ajax({
        type: "POST",
        dataType: "json",
        url: localized.ajaxurl,
        data: data,
        success: function success(response) {
          if( true === response.api_request ){

            var token = JSON.parse(sessionStorage.getItem("fmp_user"));
            if(token){
              if ($('#fmp-order-success').length){
                $("#fmp-order-success").show();
                $('#fmp-order-success').on('click', function(e) {
                  var redirect = localized.api_url + '/authenticate/external?token=' + token;
                  window.location.href = redirect;
                });
              }
            }else {
              $("#fmp-order-success").hide();
            }
          }
        },
      });
    }
  });
})(jQuery);
